var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 5.9375C7.375 6.43478 7.17746 6.91169 6.82583 7.26333C6.47419 7.61496 5.99728 7.8125 5.5 7.8125C5.00272 7.8125 4.52581 7.61496 4.17417 7.26333C3.82254 6.91169 3.625 6.43478 3.625 5.9375C3.625 5.44022 3.82254 4.96331 4.17417 4.61167C4.52581 4.26004 5.00272 4.0625 5.5 4.0625C5.99728 4.0625 6.47419 4.26004 6.82583 4.61167C7.17746 4.96331 7.375 5.44022 7.375 5.9375Z",
    stroke: "#9B9B9B",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.25C8.03688 1.25 10.1875 3.3925 10.1875 5.99187C10.1875 8.6325 8.00187 10.4856 5.98312 11.7456C5.83619 11.8303 5.66959 11.8749 5.5 11.8749C5.33041 11.8749 5.16381 11.8303 5.01688 11.7456C3.00188 10.4731 0.8125 8.64187 0.8125 5.99187C0.8125 3.3925 2.96312 1.25 5.5 1.25Z",
    stroke: "#9B9B9B",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12.5C9.25 13.1906 7.57125 13.75 5.5 13.75C3.42875 13.75 1.75 13.1906 1.75 12.5",
    stroke: "#9B9B9B",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c6d38b25591ac2403d0f59c540336c7b.svg";
export { ForwardRef as ReactComponent };